<template>
  <div>
    <div class='d-flex flex-wrap'>
      <div class='ma-2' v-if='src'>
        <v-sheet class='border' width='120' height='120' @click='chooseFile'>
          <div class='title_img'>{{ title }}</div>
          <v-row justify='center' align='center' style='height: 100%; position: relative;'>
            <div align='center'>
              <v-img height='100px' width='100px' :src='imgsrc'></v-img>
            </div>
            <v-icon @click.stop='del()' class='close' size='26'>mdi-close-circle</v-icon>
          </v-row>
        </v-sheet>
      </div>
      <div class='ma-2' v-if='!src'>
        <v-sheet class='border' width='120' height='120' @click='chooseFile'>
          <div class='title'>{{ title }}</div>
          <v-row justify='center' align='center' style='height: 100%; position: relative;'>
            <div align='center'>
              <v-img :height='imgWide' :width='imgWide' :src='imgSrc'></v-img>
            </div>
          </v-row>
        </v-sheet>
      </div>
    </div>
    <input type='file' ref='fileInput' accept='image/*' @change='getFile' style='display: none' />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'

export default {
  props: ['orgData', 'showAdd', 'title', 'src'],
  data() {
    return {
      // eslint-disable-next-line global-require
      imgSrc: require('../assets/add.png'),
      imgWide: '30px',
      imgsrc: null,
      imgList: []
    }
  },
  created() {
  },
  mounted: function() {
    this.init()
  },
  watch: {
    src(val) {
      if (val) {
        this.imgsrc = val
      } else {
        this.imgsrc = null
      }
    },
    imgsrc(val) {
      if (val) {
        this.imgsrc = val
      } else {
        this.imgsrc = null
      }
    }
  },
  methods: {
    init() {
      if (this.src) {
        this.imgsrc = this.src
      } else {
        this.imgsrc = null
      }
    },

    del() {
      this.imgsrc = null
      this.$refs.fileInput.value = null
      this.$emit('getImg', null)
    },

    chooseFile() {
      console.log('zheli')
      this.$refs.fileInput.click()
    },
    getFile(e) {
      var _self = this
      var inputFile = e.target
      if (!inputFile.files || inputFile.files.length <= 0) {
        return
      }
      var file = inputFile.files[0]
      var formData = new FormData()
      formData.append('file', file)
      formData.append('SaveDir', 'Map/MapItem')
      this.$ajax({
        url: `${process.env.VUE_APP_API_BASE_URL}file`,
        method: 'post',
        headers: { Authorization: 'Bearer ' + getToken(), 'Content-Type': 'application/json' },
        data: formData,
        dataType: 'josn',
        async: false
      }).then(function(res) {
        const filePath = res.data.data.fileUrl
        _self.imgsrc = filePath
        _self.$emit('getImg', filePath)
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.border {
  position: relative;
  border: 1px solid #888;
  border-radius: 4px;
  cursor: pointer;
}

.ma-2 {
  margin: 0 !important;
}

.title {
  position: absolute;
  top: 10px;
  width: 100%;
  text-align: center;
  font-size: 16px !important;
  color: #777;
  font-weight: 500;
}

.title_img {
  position: absolute;
  top: -12px;
  left: 5px;
  background: #fff;
  font-size: 12px !important;
  color: #777;
  font-weight: 500;
}

.close {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #fff;
  border-radius: 25px;
}
</style>
